export const state = () => ({
  categories: [],
  categoriesList: [],
  snackBar: {
    text: null
  },
  section: {},
  sectionMaterialTypes: {},
  sectionBodyTypes: {},
  sectionAwarenessLevels: {},
  loading: false
})
export const mutations = {
  LOADACATEGORIES (state, payload) {
    state.categories = payload
  },
  ADDCATEGORYLIST (state, payload) {
    state.categoriesList = payload
  },
  ADDCATEGORY (state, payload) {
    state.categories.push(payload)
  },
  EDITCATEGORY (state, payload) {
    state.categories[payload.index] = payload.category
  },
  DELETECATEGORY (state, categoryIndex) {
    state.categories.splice(categoryIndex, 1)
  },

  SHOWSNACKBAR (state, snackBarText) {
    state.snackBar.text = snackBarText
  },
  HIDESNACKBAR (state) {
    state.snackBar.text = null
  },
  SETLOADING (state, payload) {
    state.loading = payload
  },

  UPDATECATEGORY (state, payload) {
    state.categories.categories = payload
  },
  SETSECTION (state, payload) {
    state.section = payload.response
    switch (payload.sectionType) {
      case 'material-types':
        state.sectionMaterialTypes = payload.response
        break
      case 'body-types':
        state.sectionBodyTypes = payload.response
        break
      case 'awareness-levels':
        state.sectionAwarenessLevels = payload.response
        break
      default:
        return []
    }
  }
}
export const actions = {
  async fetch ({ commit, dispatch }, payload) {
    commit('SETLOADING', true)
    dispatch('fetchList')
    if (payload !== null && payload !== undefined) {
      return await this.$axios
        .$get('/categories', {
          params: {
            search_text: payload.search_text,
            page: payload.page,
            per_page: payload.per_page,
            orderBy: payload.orderBy,
            locale: 'ar'
          }
        })
        .then((response) => {
          commit('SETLOADING', false)
          commit('LOADACATEGORIES', response.data)
        })
        .catch(() => {
          commit('SETLOADING', false)
        })
    } else {
      return await this.$axios
        .$get('/categories', {
          params: {
            search_text: '',
            page: 1,
            per_page: 6,
            orderBy: 'created_at',
            locale: 'ar'
          }
        })
        .then((response) => {
          // response.data.categories.forEach((category) => {
          commit('SETLOADING', false)
          commit('LOADACATEGORIES', response.data)
        })
        .catch(() => {
          commit('SETLOADING', false)
        })
    }
  },
  async filter ({ commit }, payload) {
    if (payload !== null && payload !== undefined) {
      commit('SETLOADING', true)
      const response = await this.$axios.$post('/categories', payload)
      commit('SETLOADING', false)
      commit('LOADACATEGORIES', response.data)
      return response
    }
  },

  async fetchSection ({ commit }, payload) {
    commit('SETLOADING', true)
    return await this.$axios
      .$get(`/${payload.sectionType}`, {
        params: {
          search_text: payload.filters.search_text,
          page: payload.filters.page,
          per_page: payload.filters.per_page
        }
      })
      .then((response) => {
        commit('SETLOADING', false)
        commit('SETSECTION', {
          response: response.data,
          sectionType: payload.sectionType
        })
      })
      .catch((error) => {
        commit('SETLOADING', false)
        console.log(error)
      })
  },
  async addSectionItem ({ commit, dispatch }, payload) {
    return await this.$axios.$post(
      `/${payload.sectionType}`,
      payload.form_data
    )
  },
  async editSectionItem ({ commit }, payload) {
    commit('SETLOADING', true)
    const response = await this.$axios.$post(
      `/${payload.sectionType}/${payload.id}`,
      payload.form_data
    )
    commit('SETLOADING', false)
    return response
  },

  deleteSectionItem ({ commit, dispatch }, payload) {
    return this.$axios.$delete(`/${payload.sectionType}`, {
      data: {
        ids: [payload.id]
      }
    })
  },

  async fetchList ({ commit }) {
    return await this.$axios
      .$get('/categories', {
        params: {
          list: true
        }
      })
      .then((response) => {
        commit('ADDCATEGORYLIST', response.data.categories)
      })
  },
  async addCategory ({ commit, dispatch }, payload) {
    return await this.$axios.$post('/categories', payload)
  },
  async editCategory ({ commit }, payload) {
    return await this.$axios.$post(
      `/categories/${payload.id}`,
      payload.form_data
    )
  },
  deleteCategory ({ commit, dispatch }, categoryIndex) {
    return this.$axios.$delete('/categories', {
      data: {
        ids: [categoryIndex]
      }
    })
  }
}
